// extracted by mini-css-extract-plugin
export default {"iframe":"EmailIframePreview_iframe__h7b5e"};